import { render, staticRenderFns } from "./dialog-detailpackage.vue?vue&type=template&id=57865e90&"
import script from "./dialog-detailpackage.vue?vue&type=script&lang=js&"
export * from "./dialog-detailpackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports